import { SVGAttributes } from 'react';

interface IconProps extends SVGAttributes<SVGElement> {
  name: string;
  size?: number;
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
}

export default function Icon({ name, stroke, size, width, height, fill, ...otherProps }: IconProps) {
  
  return (
    <svg
      {...otherProps}
      width={width ?? size}
      height={height ?? size}
      fill={fill}
      stroke={stroke}
      >
        <use href={`/sprites.svg#${name}`} />
      </svg>
  )
};
